<template>
  <k-panel style="" class="dashboard-instance-container">
    <template v-slot:left-buttons>
      {{ title }}
<!--      <k-btn no-margin v-tooltip="'Edit'" size="m" icon icon-name="edit" @click="open_instance"></k-btn>
      <k-btn no-margin v-tooltip="'Open gui'" size="m" icon @click.stop="open_gui" v-if="have_streamer" icon-name="tune"></k-btn>
      <k-btn no-margin v-tooltip="'Open terminal'" size="m" icon @click.stop="open_ssh" icon-name="terminal"></k-btn>
      <k-btn no-margin v-tooltip="'Open VNC'" size="m" icon @click.stop="open_vnc"><k-icon type="symbol" size="m">desktop_landscape</k-icon></k-btn>
      <k-dialog
        width="800"
        v-if="$is_admin()"
        v-model="issuebot_dialog"
        :persistent="true"
        no-click-animation
      >
        <template #activator>
          <k-btn no-margin v-tooltip="'Issue'" size="m" icon @click="issuebot_dialog = !issuebot_dialog" icon-name="bug_report"></k-btn>
        </template>
        <k-panel class="ks-floating-menu">
          <template #title>
            Issuebot
          </template>
          <template #buttons>
            <k-btn size="m" icon icon-name="close" @click="close_issuebot_dialog"></k-btn>
          </template>

          <template #default>
            <k-text-field textarea v-model="issuebot_description" label="Description"></k-text-field>
            <k-text-field textarea v-model="issuebot_command" label="Command" readonly @click="$event.target.select()"></k-text-field>
            <k-text-field textarea v-model="issuebot_result" label="Result" readonly></k-text-field>

            <k-btn flat @click="send_issuebot_command" v-if="issuebot_enabled" :loading="issuebot_running">Send issue</k-btn>
            <k-btn flat @click="close_issuebot_dialog" v-if="!issuebot_enabled" >Close</k-btn>
          </template>

        </k-panel>
      </k-dialog>

      <k-btn no-margin v-tooltip="'Show password'" size="m" icon @click.stop="show_password = !show_password" v-if="$is_admin()" icon-name="lock"></k-btn>
      <div v-if="$is_admin() && show_password" style="margin-left: 10px; color: #777;">
        {{ssh_password}}
      </div>-->
    </template>
    <template v-slot:buttons>
      <k-btn no-margin v-tooltip="'Edit'" size="m" icon icon-name="edit" @click="open_instance"></k-btn>
      <k-btn no-margin v-tooltip="'Open gui'" size="m" icon @click.stop="open_gui" v-if="have_streamer" icon-name="tune"></k-btn>
      <k-btn no-margin v-tooltip="'Open terminal'" size="m" icon @click.stop="open_ssh" icon-name="terminal"></k-btn>
      <k-btn no-margin v-tooltip="'Open VNC'" size="m" icon @click.stop="open_vnc"><k-icon type="symbol" size="m">desktop_landscape</k-icon></k-btn>
      <k-dialog
        width="800"
        v-if="$is_admin()"
        v-model="issuebot_dialog"
        @close="close_issuebot_dialog"
      >
        <template #activator>
          <k-btn no-margin v-tooltip="'Issue'" size="m" icon @click="issuebot_dialog = !issuebot_dialog" icon-name="bug_report"></k-btn>
        </template>
        <k-panel class="ks-floating-menu">
          <template #title>
            Issuebot
          </template>
          <template #buttons>
            <k-btn size="m" icon icon-name="close" @click="close_issuebot_dialog"></k-btn>
          </template>

          <template #default>
            <k-text-field textarea v-model="issuebot_description" label="Description" required></k-text-field>
            <k-text-field textarea v-model="issuebot_steps" label="Steps" readonly @click="$event.target.select()"></k-text-field>
            <k-autocomplete v-model="issuebot_support" :items="issuebot_support_options" label="Technical support" item-text="label" item-value="value"></k-autocomplete>
            <k-text-field textarea v-model="issuebot_result" label="Result" readonly></k-text-field>

            <k-btn flat @click="send_issuebot_command" v-if="issuebot_enabled" :loading="issuebot_running">Send issue</k-btn>
            <k-btn flat @click="close_issuebot_dialog" v-if="!issuebot_enabled" >Close</k-btn>
          </template>

        </k-panel>
      </k-dialog>

      <k-btn no-margin v-tooltip="'Show password'" size="m" icon @click.stop="show_password = !show_password" v-if="$is_admin()" icon-name="lock"></k-btn>
      <div v-if="$is_admin() && show_password" style="margin-left: 10px; color: #777;">
        {{ssh_password}}
      </div>


     <k-menu bottom right v-if="have_streamer" :transition="false">
        <template v-slot:activator="{ on }">
          <k-btn no-margin  size="m" icon v-on="on" icon-name="more_vert"></k-btn>
        </template>
        <template #default>
          <div>
            <div style="height: 24px;">Streamer</div>
            <k-divider/>
            <k-btn size="m" list tile flat @click="run_speedtest">
              <k-icon size="m">network_check</k-icon> Run Speedtest
            </k-btn>
            <k-divider/>

            <k-btn size="m" list tile flat @click="restart_streamer">
              <k-icon size="m">restart_alt</k-icon> Restart
            </k-btn>

            <k-btn size="m" list tile flat @click="start_streamer" v-if="streamer_status == false">
              <k-icon size="m">play_arrow</k-icon> Start
            </k-btn>
            <k-btn size="m" list tile flat @click="stop_streamer" v-if="streamer_status == true">
              <k-icon size="m">stop</k-icon> Stop
            </k-btn>
            <k-divider/>

            <k-btn size="m" list tile flat @click="update_streamer">
              <k-icon size="m">update</k-icon> Update
            </k-btn>
          </div>
        </template>
      </k-menu>
      <k-btn no-margin icon size="m" @click="$emit('input', false)" icon-name="close"></k-btn>
    </template>

    <template v-slot:default>
      <div style="height: 300px; overflow-y: auto;">
        <instance-stats :id="instance.id" :small="true" :show_title_and_channel="true" style="min-width: 100%;"></instance-stats>
      </div>
    </template>

  </k-panel>
</template>

<script>
import InstanceStats from '../instances/Stats'
import InstanceModel from '@/models/instance.js'
import ChannelModel from '@/models/channel.js'
import SettingsModel from '@/models/settings.js'

export default {
  props: ['value', 'instance'],
  components: {
    InstanceStats
  },
  data () {
    return {
      show_password: false,
      issuebot_description: "",
      issuebot_steps: "",
      issuebot_dialog: false,
      issuebot_result: "",
      issuebot_enabled: false,
      issuebot_running: false,
      issuebot_support: "none",
      issuebot_support_options: [
        { label: 'No contact with technical support', value: 'none' },
        { label: 'Contacted support, support responded', value: 'contacted' },
        { label: 'Contacted support, no response', value: 'no_answer' }
      ],
    }
  },
  created() {
    if(this.$is_admin()) {
      this.$store.dispatch("get_profile").then(() => {
        this.issuebot_enabled = true;
      });
    }

  },
  computed: {
    have_streamer() {
      return InstanceModel.is_type_transcoder(this.instance) || InstanceModel.is_type_channel(this.instance);
    },
    version() {
      return InstanceModel.version(this.instance);
    },
    channel_title_for_instance () {
      var ch = InstanceModel.channel(this.instance);
      return ChannelModel.title(ch);
    },
    channel_is_transcoder () {
      var ch = InstanceModel.channel(this.instance);
      return ChannelModel.is_transcoder(ch);
    },
    title () {
      return InstanceModel.title(this.instance);
    },
    vpn_ip () {
      return _.get(this.stats, "vpn_ip");
    },
    streamer_status () {
      return _.get(this.stats, "streamer.state", false);
    },
    stats () {
      var st = InstanceModel.status(this.instance.id);
      if (typeof(st) != "undefined") {
        return st.stats;
      }
      return;
    },
    ssh_password() {
      return InstanceModel.ssh_password(this.instance);
    }
  },
  methods: {
    close_issuebot_dialog() {
      this.$nextTick(() => {
        this.issuebot_description = "";
        this.issuebot_result = "";
        this.issuebot_dialog = false;
        this.issuebot_running = false;
        this.issuebot_enabled = true;
        this.issuebot_support = "none";
        this.issuebot_steps = "";
      });
    },
    send_issuebot_command() {
      if(!this.$is_admin()) return;
      var settings = SettingsModel.get_by_name("issuebot");
      var apikey = _.get(settings, "value.apikey");
      var host = _.get(settings, "value.host");

      if(_.isEmpty(apikey) || _.isEmpty(host) || !this.issuebot_enabled) {
        this.$message.error("Unable to create issue!");
        return;
      }
      this.issuebot_running = true;

      this.issuebot_result = "";
      var acc = this.$store.state.account;

      var ws = new WebSocket("wss://"+host+"/command?token="+apikey)
      ws.onopen = () => {
        var command = "issue";
        var description = this.issuebot_description;
        var fields = {}
        if(this.channel_is_transcoder || InstanceModel.is_type_transcoder(this.instance)) {
          if(this.channel_title_for_instance) {
            description += "\n\nChannel title: " + this.channel_title_for_instance;
          }
          fields.cloudMachineInput = this.instance.token;
          command = "cloud";
        } else if(!_.isEmpty(this.vpn_ip)) {
          var octets = this.vpn_ip.split(".");
          fields.unitMachineInput = octets[2]+"."+octets[3];
          command = "unit";
        } else {
          fields.issueTitleInput = this.title;
          command = "issue";
        }

        fields[command+"DescriptionInput"] = description;
        fields[command+"StepsInput"] = this.issuebot_steps;
        
        var data = {
          command: command,
          modal: true,
          name: acc.name || acc.email,
          user: acc.email,
          fields: fields,
          selects: {
            [command+"SupportSelect"]: this.issuebot_support
          }
        }
        ws.send(JSON.stringify(data));
      }
      ws.onmessage = (event) => {
        try {
          var data = JSON.parse(event.data);
        } catch(err) {
          return;
        }

        if(data.type == "feedback" && ["reply", "edit"].includes(data.kind)) {
          this.issuebot_result += _.get(data, "payload.content", "") + "\n";
        }

        if(data.type == "error") {
          this.issuebot_result += data.message + "\n";
          this.$message.error("Unable to create issue!");
          ws.close();
          this.issuebot_enabled = false;
        }
        if(data.type == "done") {
          this.$message.success("Issue created successfully!");
          ws.close();
          this.issuebot_enabled = false;
        }
      }
      ws.onerror = (err) => {
        this.$message.error("Unable to create issue!");
        this.issuebot_enabled = false;
      }
    },
		open_instance () {
      this.$router.push("/dashboard/instance/" + this.instance.id);
		},
    open_gui() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance));
      }
    },
    open_ssh() {
      if (InstanceModel.ssh_url(this.instance) != "") {
        window.location.href = InstanceModel.ssh_url(this.instance);
      }
    },
    open_vnc() {
      if (InstanceModel.vnc_url(this.instance) != "") {
        window.location.href = InstanceModel.vnc_url(this.instance);
      }
    },
    restart_streamer() {
      if(!confirm("Do you really want restart streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
			var self = this;
			InstanceModel.restart_streamer(this.instance, (msg) => {
				self.$message.success("Streamer restart success");
			}, (err) => {
				self.$message.error("Streamer restart failed");
			});
    },
    start_streamer() {
      if(!confirm("Do you really want start streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
			var self = this;
			InstanceModel.start_streamer(this.instance, (msg) => {
				self.$message.success("Streamer start success");
			}, (err) => {
				self.$message.error("Streamer start failed");
			});
    },
    stop_streamer() {
      if(!confirm("Do you really want stop streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
			var self = this;
			InstanceModel.stop_streamer(this.instance, (msg) => {
				self.$message.success("Streamer stop success");
			}, (err) => {
				self.$message.error("Streamer stop failed");
			});
    },
    update_streamer() {
      if(!confirm("Do you really want update streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
      var self = this;
      InstanceModel.update_streamer(this.instance, (msg) => {
        self.$message.success("Streamer update request sent");
      }, (err) => {
        self.$message.error("Streamer update request failed");
      });
    },
    run_speedtest() {
      var self = this;
      InstanceModel.send_streamer(this.instance, {"type": "speedtest"}, (msg) => {
        self.$message.success("Streamer speedtest started");
      }, (err) => {
        self.$message.error("Streamer speedtest failed");
      });
    }

  }
}
</script>
<style>
  .dashboard-instance-container {
    width: 100%;
    min-width: 750px;
    max-width: 750px;
    background: transparent !important;
  }
  @media (max-width: 768px) {
    .dashboard-instance-container {
      width: 95vw;
      width: 95dvw;;
      max-width: 95vw;
      max-width: 95dvw;
      min-width: 95vw;
      min-width: 95dvw;
    }
  }
</style>
